import Choices from "choices.js";
import Swiper from "swiper";

export default class Global {

    constructor() {
        this.initChoices();
        this.initReviews();
        this.initShowAlert();
        this.handleOffices();
        this.initDynamicPrices();
    }

    initDynamicPrices() {
        if (!window.searchData) return;

        const koophuurSelect = document.getElementById('koophuurSelect');
        const prijsMinSelect = document.getElementById('prijsMinSelect');
        const prijsMaxSelect = document.getElementById('prijsMaxSelect');

        if (!koophuurSelect || !prijsMinSelect || !prijsMaxSelect) return;

        const oldValues = window.oldFormValues || {
            koophuur: '',
            prijs_min: '',
            prijs_max: '',
        };

        if (oldValues.koophuur) {
            koophuurSelect.value = oldValues.koophuur;
        }

        function fillSelect(selectEl, data, placeholder, selectedValue = '') {
            selectEl.innerHTML = '';

            const placeholderOption = document.createElement('option');
            placeholderOption.disabled = true;
            placeholderOption.selected = true;
            placeholderOption.textContent = placeholder;
            selectEl.appendChild(placeholderOption);

            Object.entries(data).forEach(([value, label]) => {
                const option = document.createElement('option');
                option.value = value;
                option.textContent = label;

                if (selectedValue && value === selectedValue) {
                    option.selected = true;
                }

                selectEl.appendChild(option);
            });
        }

        function updatePriceSelects() {
            const currentType = koophuurSelect.value;
            let priceData;

            if (currentType === 'huur') {
                priceData = window.searchData.huurprijs;
            } else {
                priceData = window.searchData.koopprijs;
            }

            fillSelect(prijsMinSelect, priceData, 'Prijs van', oldValues.prijs_min);
            fillSelect(prijsMaxSelect, priceData, 'Prijs tot', oldValues.prijs_max);
        }

        updatePriceSelects();

        koophuurSelect.addEventListener('change', () => {
            oldValues.prijs_min = '';
            oldValues.prijs_max = '';
            updatePriceSelects();
        });
    }

    initChoices() {
        const elements = document.querySelectorAll('.js-choice');
        let choices;

        elements.forEach(element => {
            choices = new Choices(element);
        });
    }


    initReviews() {
        if (document.querySelectorAll('#reviewSlider') !== null) {
            new Swiper('#reviewSlider .swiper-container', {
                slidesPerView: 1,
                spaceBetween: 30,
                loop: true,
                autoplay: {
                    delay: 3500,
                },
                breakpoints: {
                    576: {
                        slidesPerView: 2,
                    },
                    1200: {
                        slidesPerView: 2,
                    }
                }
            });
        }
    }

    initShowAlert() {
        if (document.querySelector('#showAlert')) {
            function openCloseLogin() {
                const exitButton = document.querySelector('#popup #exit');
                const closeButton = document.querySelector('#popup #close');

                if (!getCookie('popupClosed')) {
                    openWindow();
                }

                if (closeButton) {
                    closeButton.addEventListener('click', () => {
                        closeWindow();
                    });
                }

                if (exitButton) {
                    exitButton.addEventListener('click', () => {
                        closeWindow();
                    });
                }
            }

            function openWindow() {
                const popup = document.querySelector('#popup');
                popup.classList.add('open');
            }

            function closeWindow() {
                const popup = document.querySelector('#popup');
                popup.classList.remove('open');
                setCookie('popupClosed', 'true', 1); // Set cookie to expire in 1 day
            }

            function setCookie(name, value, days) {
                const date = new Date();
                date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
                const expires = "expires=" + date.toUTCString();
                document.cookie = name + "=" + value + ";" + expires + ";path=/";
            }

            function getCookie(name) {
                const nameEQ = name + "=";
                const ca = document.cookie.split(';');
                for (let i = 0; i < ca.length; i++) {
                    let c = ca[i];
                    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
                    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
                }
                return null;
            }

            openCloseLogin();
        }
    }

    handleOffices() {
        const offices = window.officesData || [];

        const infoTriggers = document.querySelectorAll('.info-trigger');
        const popup = document.querySelector('.info-popup');
        const officeSelect = document.getElementById('officeSelect');
        const officeResult = document.getElementById('officeResult');
        const popupContent = popup.querySelector('.info-popup-content');

        let currentPopupType = null;
        let currentTrigger = null;
        let isSwitchingType = false;

        offices.forEach(office => {
            const option = document.createElement('option');
            option.value = office.id;
            option.textContent = office.name;
            officeSelect.appendChild(option);
        });

        function positionPopup(trigger) {
            const rect = trigger.getBoundingClientRect();
            const popupWidth = popup.offsetWidth;

            const popupLeft = rect.right - popupWidth + 10;
            const popupTop = rect.bottom + 8;

            popup.style.left = (window.scrollX + popupLeft) + 'px';
            popup.style.top = (window.scrollY + popupTop) + 'px';
        }

        function showPopup(trigger, popupType) {
            if (!popup.classList.contains('d-none') && currentPopupType && currentPopupType !== popupType) {
                switchPopupType(trigger, popupType);
                return;
            }

            currentPopupType = popupType;
            currentTrigger = trigger;

            popup.classList.remove('d-none');
            popup.classList.remove('show');

            positionPopup(trigger);

            void popup.offsetWidth;
            popup.classList.add('show');

            updatePopupContent();
        }

        function hidePopup() {
            popup.classList.remove('show');
            popup.addEventListener('transitionend', function endHide() {
                popup.classList.add('d-none');
                officeSelect.value = '';
                officeResult.innerHTML = '';
                currentPopupType = null;
                currentTrigger = null;
                popup.removeEventListener('transitionend', endHide);
            });
        }

        function switchPopupType(newTrigger, newType) {
            if (isSwitchingType) return;
            isSwitchingType = true;

            popupContent.classList.add('fade-out');
            popupContent.addEventListener('transitionend', function endFadeOut() {
                popupContent.removeEventListener('transitionend', endFadeOut);

                currentPopupType = newType;
                currentTrigger = newTrigger;

                officeSelect.value = '';
                officeResult.innerHTML = '';

                positionPopup(newTrigger);

                updatePopupContent();

                void popupContent.offsetWidth;
                popupContent.classList.remove('fade-out');

                popupContent.addEventListener('transitionend', function endFadeIn() {
                    popupContent.removeEventListener('transitionend', endFadeIn);
                    isSwitchingType = false;
                });
            });
        }

        function updatePopupContent() {
            officeResult.innerHTML = '';
        }

        infoTriggers.forEach(trigger => {
            trigger.addEventListener('click', function (e) {
                e.preventDefault();
                const popupType = this.getAttribute('data-popup-type');

                if (!popup.classList.contains('d-none') && currentPopupType === popupType) {
                    hidePopup();
                    return;
                }

                showPopup(this, popupType);
            });
        });

        officeSelect.addEventListener('change', function () {
            const selectedId = this.value;
            if (!selectedId) {
                officeResult.innerHTML = '';
                return;
            }

            const office = offices.find(o => o.id == selectedId);
            if (!office) {
                officeResult.innerHTML = '';
                return;
            }

            popupContent.classList.add('fade-out');
            popupContent.addEventListener('transitionend', function endChangeFadeOut() {
                popupContent.removeEventListener('transitionend', endChangeFadeOut);

                let url;
                if(office.redirect === 1){
                    url = office.website;
                }else{
                    url = office.url;
                }

                if (currentPopupType === 'hours') {
                    officeResult.innerHTML = `
                    <h4 class="mt-4">${office.name}</h4>
                    ${office.opening_hours}
                    <a class="button w-100 mt-3 justify-content-between" href="${url}"><span>Meer over dit kantoor</span><i class="icon-caret-right"></i></a>
                `;
                } else if (currentPopupType === 'contact') {
                    officeResult.innerHTML = `
                    <h4 class="mt-4">${office.name}</h4>
                    <ul>
                        <li><i class="icon-phone"></i> <a href="tel:${office.phone}">${office.phone}</a></li>
                        <li><i class="icon-envelope"></i> <a href="mailto:${office.email}">${office.email}</a></li>
                    </ul>
                    <a class="button w-100 mt-3 justify-content-between" href="${url}"><span>Meer over dit kantoor</span><i class="icon-caret-right"></i></a>
                `;
                }

                void popupContent.offsetWidth;
                popupContent.classList.remove('fade-out');
            });
        });

        document.addEventListener('click', function (e) {
            if (!popup.contains(e.target) && !Array.from(infoTriggers).some(t => t.contains(e.target))) {
                if (!popup.classList.contains('d-none')) {
                    hidePopup();
                }
            }
        });
    }
}
